import { ConnectComponent } from '../../../_components/ConnectComponent'
import { OfferTablePresenter } from './OfferTable.presenter'
import { OfferTableView } from './OfferTable.view'

export const OfferTable = ConnectComponent(OfferTableView, OfferTablePresenter)
